var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import '../EmptyTable/EmptyTable.css';
var EmptyTable = function (_a) {
    var _b;
    var centered = _a.centered, className = _a.className, children = _a.children, props = __rest(_a, ["centered", "className", "children"]);
    var emptyTableClasses = classNames('ins-c-table__empty', (_b = {}, _b["is-centered"] = centered, _b), className);
    return (_jsxs("div", __assign({ className: emptyTableClasses }, props, { children: [' ', children] })));
};
export default EmptyTable;
//# sourceMappingURL=EmptyTable.js.map